'use client';
import { css, styled } from '@mui/material/styles';
import isPropValid from '@emotion/is-prop-valid';
import {
  gutterFlexible,
  gutterXs,
} from '@repo/ui/src/styles/variables';
import { AlignH, AlignV } from '@repo/ui/src/types';
import { HorizontalAlignmentEnum, VerticalAlignmentEnum } from '@repo/ui/src/enums/shared-enums';

interface CardProps {
  imgUrl: string | null;
}

export const ToutContentCardContainer = styled('div', {
  shouldForwardProp: isPropValid,
})<CardProps>`
  min-height: inherit;
  width: 100%;
  background-image: ${(props) => (props.imgUrl ? `url("${props.imgUrl}")` : null)};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  position: relative;

  .video {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }
`;

interface CardInnerProps extends CardProps {
  verticalAlignment: AlignV;
  horizontalAlignment: AlignH;
  centerGradient: boolean;
  gradientDirection: string;
  textAlign: AlignH;
  fullWidthAndHeight?: boolean;
}

export const InnerToutContentContainer = styled('div', {
  shouldForwardProp: isPropValid,
})<CardInnerProps>`
  display: flex;
  align-items: ${(props) =>
    props.verticalAlignment === VerticalAlignmentEnum.Top
      ? 'flex-start'
      : props.verticalAlignment === VerticalAlignmentEnum.Bottom
        ? 'flex-end'
        : 'center'};
  justify-content: ${(props) =>
    props.horizontalAlignment === HorizontalAlignmentEnum.Left
      ? 'flex-start'
      : props.horizontalAlignment === HorizontalAlignmentEnum.Right
        ? 'flex-end'
        : 'center'};

  padding: ${gutterXs};
  min-height: inherit;
  position: relative;
  background: ${(props) =>
    props.imgUrl
      ? 'linear-gradient(to bottom right, rgba(0, 0, 0, .7) 0%, rgba(0, 0, 0, 0) 100%)'
      : null};

  ${(props) =>
    props.fullWidthAndHeight
      ? css`
          height: 100%;
          width: 100%;
        `
      : ''}

  ${(props) => props.theme.breakpoints.up('sm')} {
    padding-top: ${Number(gutterFlexible) * 2}vw;
    padding-bottom: ${Number(gutterFlexible) * 2}vw;
    padding-left: ${(props) =>
      props.horizontalAlignment === HorizontalAlignmentEnum.Right
        ? '35%'
        : `${Number(gutterFlexible) * 2}vw`};
    padding-right: ${(props) =>
      props.horizontalAlignment === HorizontalAlignmentEnum.Left
        ? '35%'
        : `${Number(gutterFlexible) * 2}vw`};
    background: ${(props) =>
      props.imgUrl
        ? props.centerGradient
          ? 'radial-gradient(circle, rgba(0, 0, 0, .5) 18%, rgba(0, 0, 0, 0) 100%)'
          : `linear-gradient(to ${props.gradientDirection}, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.7) 90%)`
        : null};

    & .description {
      max-width: 440px;
      margin-left: ${(props) => (props.textAlign === HorizontalAlignmentEnum.Left ? 0 : 'auto')};
      margin-right: ${(props) => (props.textAlign === HorizontalAlignmentEnum.Right ? 0 : 'auto')};
    }
  }

  ${(props) => props.theme.breakpoints.up('md')} {
    padding-left: ${(props) =>
      props.horizontalAlignment === HorizontalAlignmentEnum.Right
        ? '55%'
        : `${Number(gutterFlexible) * 2}vw`};
    padding-right: ${(props) =>
      props.horizontalAlignment === HorizontalAlignmentEnum.Left
        ? '55%'
        : `${Number(gutterFlexible) * 2}vw`};
  }
`;